export default "__VITE_ASSET__DeRaWNc1__"